import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=6daf4b14&"
import script from "./PageSelector.vue?vue&type=script&lang=js&"
export * from "./PageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports